import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  AlertController,
  IonicPage,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
} from "ionic-angular";
import Company from "models/company-details/company";
import CompanyLocation from "models/company-details/company-location";
import { UtilityService } from "providers/utility-service/utility-service";
import { AccessControlService } from "../../../app/access-control/access-control-service";
import { AuthService } from "../../../app/auth/auth.service";
import { CompanyManagementService } from "../../../providers/company-management-service/company-management-service";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import { UsersService } from "../../../providers/users-service/users.service";
import { CompanyPage } from "../company";
import { CompanyDetailsLocationGroups } from "../company-details/companyLocations/company-details-companyLocations";

@IonicPage({
  segment: "company/company-management/company-details",
})
@Component({
  selector: "locations",
  templateUrl: "locations.html",
})
export class CompanyDetailsPage extends CompanyPage implements OnInit {
  @ViewChild("locationgrid") locationGrid: CompanyDetailsLocationGroups;

  query: string = "";
  company: Company | undefined;
  private hasEntered = false;

  constructor(
    protected accessControlService: AccessControlService,
    protected navCtrl: NavController,
    protected navParams: NavParams,
    protected loader: LoadingController,
    protected userService: UsersService,
    protected stateManagementService: StateManagementService,
    protected companyManagementService: CompanyManagementService,
    protected alertController: AlertController,
    protected modalController: ModalController,
    protected utilityService: UtilityService,
    protected authSvc: AuthService,
    private elementRef: ElementRef
  ) {
    super(
      accessControlService,
      navCtrl,
      navParams,
      userService,
      stateManagementService,
      authSvc
    );
    this.company = this.authSvc.getCompany();
  }

  ionViewDidEnter() {
    this.stateManagementService.setSectionId("Location");

    // Coming BACK from the Facility form (a save pops the nav stack) must show the new
    // or edited location. The grid loads itself once on ngOnInit, so only reload on a
    // RE-entry — otherwise the first visit would fire the search twice.
    if (this.hasEntered && this.locationGrid) {
      this.locationGrid.onPageChange(this.locationGrid.currentPage);
    }
    this.hasEntered = true;
  }

  /** Open the Facility form to create a new location for this company. */
  addLocation() {
    this.navCtrl.push("Facility", {
      companyId: this.company ? this.company.companyId : "",
      companyName: this.company ? this.company.name : "",
    });
  }

  /** Open an existing location in the Facility form (edit mode). */
  editLocation(location: CompanyLocation) {
    if (!location) return;
    this.navCtrl.push("Facility", {
      facilityData: location,
      companyId: this.company ? this.company.companyId : "",
      companyName: this.company ? this.company.name : "",
    });
  }

  ngAfterViewInit() {
    const searchIcon = this.elementRef.nativeElement.querySelector(
      ".searchbar-search-icon"
    );
    if (searchIcon) {
      searchIcon.addEventListener(
        "click",
        this.getItemsBySearchFilter.bind(this)
      );
    }
  }

  // setCompnay(user: IUser) {
  //   this.company = {
  //     companyId: '',
  //     name: ''
  //   };
  //   let multiCompanies = user.organizations.filter(o => o.OrgType === 'COMPANY').length > 1;
  //   if (multiCompanies) {
  //     let currentOrg = user.organizations.find(o => o.OrgId === user.selectedOrg && o.OrgType === 'COMPANY');
  //     if (currentOrg) {
  //       this.company.companyId = currentOrg.OrgId;
  //       this.company.name = currentOrg.OrgName;
  //     }
  //   } else {
  //     this.company.companyId = user.orgId;
  //     this.company.name = user.orgName;
  //   }
  // }

  getItemsBySearchFilter() {
    if (this.query) {
      this.locationGrid.query = this.query;
      this.locationGrid.onPageChange(0);
    }
  }

  onSearchCancel() {
    this.query = "";
    this.locationGrid.query = this.query;
    this.locationGrid.onPageChange(0);
  }

  clearSearchInput() {
    this.query = "";
    this.locationGrid.query = this.query;
    this.locationGrid.onPageChange(0);
  }

  checkClearInput() {
    if (!this.query || this.query.trim().length === 0) {
      this.clearSearchInput();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/company/locations/locations.ts